import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const permissionGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const actionIds = route.data?.['actions'] as number[] | undefined;
  const moduleIds = route.data?.['modules'] as number[] | undefined;

  const hasModuleAccess = !moduleIds?.length || authService.hasAnyModule(moduleIds);
  const hasActionAccess = !actionIds?.length || authService.hasAnyAction(actionIds);

  if (hasModuleAccess && hasActionAccess) {
    return true;
  }

  return router.createUrlTree(['/admin']);
};
